module.exports = __webpack_public_path__ + "static/media/SwipeRight.bb499a0c.png";